import _Vue from 'vue'
import * as URL from "url";

interface UrlManager {
  init: () => void,
  parameters: { [key: string]: { callback: () => void, value: string } },
  registerUrlParameter: (name: string, callback: () => void, clear?: string) => void,
  deleteUrlParameter: (name: string) => void,
  setUrlParameter: (name: string, value: string) => void,
  getUrlParameter: (name: string) => string,
  onStateChanged: () => void
}

declare module 'vue/types/vue' {
  interface Vue {
    $urlManager: UrlManager
  }
}

export default function UrlManager(Vue: typeof _Vue, router: any) {
  Vue.prototype.$urlManager = {
    init() {
      window.addEventListener('popstate', this.onStateChanged.bind(this))
    },
    parameters: {},
    registerUrlParameter(name: string, callback: void, clear?: string): void {
      if (this.parameters[name]) return
      this.parameters[name] = {
        callback,
        clear,
        value: this.getUrlParameter(name)
      }
    },
    deleteUrlParameter(name: string) {
      if (!this.parameters[name]) return
      delete this.parameters[name]
    },
    setUrlParameter(name: string, value: string): void {
      if (value === this.parameters[name].value) return
      this.parameters[name].value = value
      const query = JSON.parse(JSON.stringify(router.app.$route.query))
      if (value.length > 0) {
        query[name] = value
      } else {
        delete query[name]
      }
      const clear = this.parameters[name].clear && this.parameters[this.parameters[name].clear]
      if (clear) {
        delete query[this.parameters[name].clear]
      }
      router.app.$router.push({
        query: query
      })
      if (clear) {
        this.parameters[this.parameters[name].clear].callback()
      }
    },
    getUrlParameter(name: string): string {
      return router.app.$route.query[name] || ''
    },
    onStateChanged(): void {
      if (Object.keys(this.parameters).length < 1) return
      Object.keys(this.parameters).forEach((key: string) => {
        if (this.parameters[key].value === this.getUrlParameter(key)) return
        this.parameters[key].value = this.getUrlParameter(key)
        this.parameters[key].callback()
      })
    }
  }
}